(() => {
  const openerSelector = '[data-vk-discreet-shipping-open]';
  const closeSelector = '[data-vk-discreet-shipping-close]';

  const bind = (dialog) => {
    if (!dialog || dialog.dataset.vkBound === 'true') return;
    dialog.dataset.vkBound = 'true';

    const close = () => {
      if (dialog.open) dialog.close();
    };

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog.querySelector(closeSelector)?.addEventListener('click', close);
    dialog.addEventListener('close', () => {
      dialog.vkOpener?.focus({ preventScroll: true });
    });
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest(openerSelector);
    if (!opener) return;

    const id = opener.getAttribute('aria-controls');
    const dialog = id ? document.getElementById(id) : null;
    if (!(dialog instanceof HTMLDialogElement)) return;

    event.preventDefault();
    bind(dialog);
    dialog.vkOpener = opener;
    dialog.showModal();
    dialog.querySelector(closeSelector)?.focus({ preventScroll: true });
  });

  document.querySelectorAll('dialog.vk-discreet-shipping-modal').forEach(bind);
})();
